module.exports = __webpack_public_path__ + "img/744.f7cacf50.jpg";